import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import {
  FETCH_PROMPTS_REQUEST,
  CREATE_PROMPT_REQUEST,
  UPDATE_PROMPT_REQUEST,
  DELETE_PROMPT_REQUEST,
  fetchPromptsSuccess,
  fetchPromptsFailure,
  createPromptSuccess,
  createPromptFailure,
  updatePromptSuccess,
  updatePromptFailure,
  deletePromptSuccess,
  deletePromptFailure,
  FETCH_PROMPTS_BY_AGENT_REQUEST,
  fetchPromptsByAgentSuccess,
  fetchPromptsByAgentFailure,
  updatePromptVersionSuccess,
  updatePromptVersionFailure,
  UPDATE_PROMPT_VERSION_STATUS_REQUEST,
  fetchPromptsRequest,
} from '../actions/promptAction';
import { getBaseUrl } from '../utils/getBaseUrl';

const API_BASE_URL = `${getBaseUrl()}/api/prompt`;
const getAuthToken = () =>  localStorage.getItem('authToken');

function* fetchPromptsSaga(action) {
  try {
    const token = getAuthToken();
    const { page = 1, limit = 10, search = '', agentId } = action.payload || {};
    const response = yield call(axios.get, API_BASE_URL, {
      headers: { Authorization: `Bearer ${token}` },
      params: { page, limit, search, agentId },
    });
    console.log("API Response", response.data);
    yield put(fetchPromptsSuccess(response.data));
  } catch (error) {
    yield put(fetchPromptsFailure(error.message));
  }
}

function* createPromptSaga(action) {
  try {
    const token = getAuthToken();
    const response = yield call(axios.post, API_BASE_URL, action.payload.data, {
      headers: { Authorization: `Bearer ${token}` },
    });
    yield put(createPromptSuccess(response.data));

    // Trigger refresh after success
    yield put(fetchPromptsRequest(action.payload.meta));
  } catch (error) {
    yield put(createPromptFailure(error.message));
  }
}

function* updatePromptSaga(action) {
  const { promptId, promptData, meta } = action.payload;
  try {
    const token = getAuthToken();
    const response = yield call(axios.put, `${API_BASE_URL}/${promptId}`, promptData, {
      headers: { Authorization: `Bearer ${token}` },
    });
    yield put(updatePromptSuccess(response.data));

    // Refetch the updated list
    yield put(fetchPromptsRequest(meta));
  } catch (error) {
    yield put(updatePromptFailure(error.message));
  }
}

function* deletePromptSaga(action) {
  try {
    const token = getAuthToken();
    yield call(axios.delete, `${API_BASE_URL}/${action.payload.promptId}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    yield put(deletePromptSuccess(action.payload.promptId));

    // Trigger refresh after success
    yield put(fetchPromptsRequest(action.payload.meta));
  } catch (error) {
    yield put(deletePromptFailure(error.message));
  }
}

function* fetchPromptsByAgentSaga(action) {
  try {

    const token = getAuthToken();
    const { agentId, model } = action.payload;
    const response = yield call(axios.get, `${API_BASE_URL}/agent/id/${agentId}`, {
      headers: { Authorization: `Bearer ${token}` },
      params : { model },
    });
    console.log("Prompt Data Fetched", response.data);  // Debugging Line

    yield put(fetchPromptsByAgentSuccess(response.data));
  } catch (error) {
    console.error("Error fetching prompts:", error.message);  // Improved error logging
    yield put(fetchPromptsByAgentFailure(error.message));
  }
}

function* updatePromptVersionStatusSaga(action) {
  try {
    const token = getAuthToken();
    const { promptId, status, page = 1, limit = 10, search = '', agentId } = action.payload;

    // Call the API to update prompt version status
    const response = yield call(axios.put, `${API_BASE_URL}/change-active/${promptId}`, {}, {
      headers: { Authorization: `Bearer ${token}` },
    });

    // Dispatch success for update
    yield put(updatePromptVersionSuccess(response.data));

    // Now refetch the list after update
    yield put(fetchPromptsRequest({ page, limit, search, agentId }));
  } catch (error) {
    yield put(updatePromptVersionFailure(error.message));
  }
}

export default function* promptSaga() {
  yield takeLatest(FETCH_PROMPTS_REQUEST, fetchPromptsSaga);
  yield takeLatest(CREATE_PROMPT_REQUEST, createPromptSaga);
  yield takeLatest(UPDATE_PROMPT_REQUEST, updatePromptSaga);
  yield takeLatest(DELETE_PROMPT_REQUEST, deletePromptSaga);
  yield takeLatest(FETCH_PROMPTS_BY_AGENT_REQUEST, fetchPromptsByAgentSaga)
  yield takeLatest(UPDATE_PROMPT_VERSION_STATUS_REQUEST, updatePromptVersionStatusSaga);
}
